import { Box, Stack } from '@mui/system';
import RoleSettingsForm from './role-settings-form';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { useQuery } from '@tanstack/react-query';
import { getAllRolesQuery } from '../../../../api/users-api';
import { useParams } from 'react-router-dom';

import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function RoleSettings() {
  const { roleName } = useParams() as { roleName: string };
  const { changeLogRoles } = useUserSettings();
  const { data: roles, isLoading } = useQuery(getAllRolesQuery());
  const currentRole = roles?.find((role) => role.roleName === roleName);

  if (isLoading || !currentRole) {
    return (
      <Box sx={{ position: 'relative', px: 2, pt: 2 }}>
        <Typography sx={{ fontSize: 24, textAlign: 'center', fontWeight: 400 }}>
          Role Settings
        </Typography>
        <Button
          variant="contained"
          disabled={true}
          sx={{ position: 'absolute', top: 0, right: 0 }}
        >
          Save
        </Button>
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Description
        </Typography>
        <Skeleton
          variant="text"
          width={400}
          height={70}
          sx={{ marginLeft: 4 }}
        />
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Change Log Settings
        </Typography>
        <Stack
          sx={{
            pt: 1,
            px: 4,
          }}
        >
          <Skeleton variant="text" width={400} height={70} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Password Settings
        </Typography>
        <Stack
          sx={{
            pt: 1,
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={70} />
        </Stack>
        <Divider />
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Notification Settings
        </Typography>
        <Stack
          sx={{
            pt: 1,
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={70} />
        </Stack>
      </Box>
    );
  }

  return (
    <RoleSettingsForm role={currentRole} changeLogRoles={changeLogRoles} />
  );
}
